import Loader from 'components/Common/Loader';
import useTranslate from 'hooks/useTranslate';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useVerifyAccountMutation } from 'services';
import AuthHeadingPanel from './AuthHeadingPanel';
import AuthLeftPanel from './AuthLeftPanel';
import { USER_TYPES } from 'constants';

const AccountVerify = () => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');

	const { mutateAsync: VerifyAccountMutation, isPending } = useVerifyAccountMutation();
	useEffect(() => {
		if (token) {
			VerifyAccountMutation(token)
				.then((res: any) => {
					if (res?.success) {
						toast.success(res?.message);
					} else {
						toast.error(res?.message);
					}
					navigate(`/login?userType=${res?.data?.userType || USER_TYPES.SEEKER}`);
				})
				.catch((error) => {
					console.error('Failed to verify account:', error);
					toast.error(translate('ToastMessage.errorOccurredWhileVerifyingTheAccount'));
					navigate(`/login?userType=${USER_TYPES.SEEKER}`);
				});
		} else {
			toast.error('Common.invalidToken');
			navigate(`/login?userType=${USER_TYPES.SEEKER}`);
		}
	}, [token]);

	return (
		<div className="auth bg-white d-flex flex-column flex-lg-row">
			<div className="auth-left-content">
				<AuthLeftPanel />
			</div>
			<div className="auth-right-content flex-1 d-flex align-items-center justify-content-center position-relative">
				<div className="auth-form mb-0 mt-5mx-3 my-5 m-md-5">
					{isPending ? (
						<Loader />
					) : (
						<AuthHeadingPanel description={translate('Common.pleaseWait')} />
					)}
				</div>
			</div>
		</div>
	);
};

export default AccountVerify;
